
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { getDeliveryDateAndTime, formatFastestDeliveryTime, getPrice } from '@/features/common/helpers';
import { AvailableService } from '@/features/shipment/types';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';
import PieChart from './PieChart.vue';
import LabelTag from './LabelTag.vue';
import ServiceItemDetails from './ServiceItemDetails.vue';

@Component({
  components: {
    PieChart,
    LabelTag,
    ServiceItemDetails,
  },
})
export default class HighlightedService extends Vue {
  @Prop({ required: true }) service!: AvailableService;

  @Prop({ default: false }) fastest!: boolean;

  private showExpand = false;

  @Watch('showExpand')
  private onExpand(expanded: boolean): void {
    if (expanded) this.$emit('expand', this.service);
  }

  private getPrice = getPrice;

  private getCarrierLogoCode = getCarrierLogoCode;

  private getDisplayCarrierCode = getDisplayCarrierCode;

  get deliveryDateAndTime() {
    return getDeliveryDateAndTime(this.service.deliveryTime);
  }

  get fastestDeliveryTime() {
    return formatFastestDeliveryTime(this.service.deliveryTime);
  }

  get amountSaved() {
    return this.service.regularPrice - this.service.total;
  }

  get percentSaved() {
    if (!this.service.regularPrice) return 0;
    return Math.round((this.amountSaved / this.service.regularPrice) * 100);
  }

  get colorHex() {
    return this.fastest ? '#FFA43C' : '#2BC5CB';
  }

  get label() {
    return this.fastest ? this.$t('shipment.yourResults.fastest') : this.$t('shipment.yourResults.cheapest');
  }

  get hidePieChart() {
    return this.fastest && this.fastestDeliveryTime === null;
  }
}
